import { FormattedMessage } from 'react-intl'

import { useListPartnerCommissions } from '@/api/gen'
import { CommissionsTable } from '@/components/commissions-table'
import { EmptyState } from '@/components/empty-state'
import { InlineQueryError } from '@/components/inline-query-error'
import { useReportQueryError } from '@/hooks/use-report-query-error'

export const CommissionsTab = ({ partnerId }: { partnerId: string }) => {
  const commissionsQuery = useListPartnerCommissions(partnerId)
  const { data: commissions, isLoading, isError, refetch } = commissionsQuery

  // Forward load failures to Sentry — the bare app QueryClient has no global
  // sink. Previously a failed commissions query fell through to the EmptyState
  // ("No commissions for this partner."), masking the failure as a legitimate
  // empty list and losing the observability signal.
  useReportQueryError(commissionsQuery, 'useListPartnerCommissions failed: ')

  const rows = commissions ?? []
  if (isError) {
    return (
      <InlineQueryError
        data-tst="partner-commissions-error"
        messageId="admin.partnerDetail.commissions.loadError"
        onRetry={() => void refetch()}
      />
    )
  }
  if (!isLoading && rows.length === 0) {
    return <EmptyState title={<FormattedMessage id="admin.partnerDetail.commissions.empty" />} />
  }

  return (
    <CommissionsTable
      showCustomerEmail
      data={rows}
      getRowId={(row) => row.id}
      loading={isLoading}
    />
  )
}
